export const stepsConfig = {
  start_screen: 'start',
  head_device_selector_screen: 'head_device_selector',
  configuration_editor_screen: 'configuration_editor',
  power_supply: 'power_supply',
  accessorize: 'accessorize',
  save_screen: 'save',
}

export const softwareStepsConfig = {
  software_selection: 'software_selection',
  licence_selector: 'licence_selector',
  service_plan: 'service_plan',
  save_screen: 'save',
}

export const powerSupplySteps = {
  requirements: 'requirements',
  consumption_estimation: 'consumption_estimation',
  segment_grouping: 'segment_grouping'
}

export const configurationStatuses = {
  in_progress: 'IN_PROGRESS',
  finalized: 'FINALIZED',
  finished: 'FINISHED',
}

export const possible_starter_selections = {
  PLC_IO: 'PLC',
  IO_ONLY: 'BC',
  PAC: 'PAC',
  EDGE: 'EDGE',
  SOFTWARE_LICENCE: "SOFTWARE_LICENCE"
};

export const tool_starter_selections = {
  modicon_controller: [possible_starter_selections.PLC_IO, possible_starter_selections.PAC, possible_starter_selections.EDGE],
  industrial_automation_software: [possible_starter_selections.SOFTWARE_LICENCE]
}

export const configurationModuleType = {
  com_module: 'COM_MODULE',
  head_module: 'HEAD_MODULE',
  io_module: 'IO_MODULE',
  cartridges: 'CARTRIDGES',
  power_supply: 'POWER_SUPPLY',
  redbox: 'REDBOX'
};

export const rangeProductType = {
  plc: 'plc',
  bc: 'bc',
  unknown: 'unknown',
};

export const busExpansionType = {
  transmitter: 'transmitter',
  receiver: 'receiver',
  both: 'both',
  none: 'none',

  isTransmitter(type) {
    return this.transmitter === type || this.both === type;
  },
  isReceiver(type) {
    return this.receiver === type || this.both === type;
  },
}

export const moduleQuestionTypes = {
  io_module: configurationModuleType.io_module,
  com_module: configurationModuleType.com_module
}

export const accessoriesType = {
  accessory: 0,
  warranty: 1,
  auxiliary: 2,
  sensor: 3,
  spare_part: 4,
  option: 5
}

export const exportNames = {
  machine_expert: "EXPORT_MACHINE_EXPERT",
  xls: "EXPORT_XLS",
  png: "EXPORT_PNG",
  pdf: "EXPORT_PDF",
  architecture_pdf: "EXPORT_ARCHITECTURE_PDF",
  my_product: "EXPORT_MY_PRODUCT"
}

export const io_island_question = 'IO_ISLAND';

export const remote_area_question = 'REMOTE_AREA';

export const power_supply_question = 'POWER_SUPPLY';

export const rack_question = 'RACKS';

export const api_base_url = process.env.REACT_APP_API_URL;


export const front_base_url = process.env.REACT_APP_STORAGE_URL ? process.env.REACT_APP_STORAGE_URL : '';

export const default_pdf_font_url = `${front_base_url}/fonts/roboto-medium-webfont.ttf`;

export const chinese_pdf_font_url = `${front_base_url}/fonts/msyh.ttf`;

export const consumptionWarningPercent = 0.1;

export const possibleLengthUnitFormat = {
  mm: 'mm',
  inch: 'inch'
}

export const zelio_extension = "Zelio extension";

export const preferredProductReference = {
  none: 'NONE',
  ean: 'EAN',
  enum: 'E-NUMBER'
}

export const m172_ranges = [
  'Modicon M172 Performance',
  'Modicon M172 Optimized',
  'Modicon M173 Optimized',
];

export const m171_ranges = [
  'Modicon M171 Optimized'
];

export const tm172sig_type = "IIoT Secure Interface Gateway";

export const pacdrive_ranges = [
  'PacDrive LMC Eco',
  'PacDrive LMC Pro2'
];

export const pac_ranges = {
  m580: 'Modicon M580',
  m580_harsh: 'Modicon M580 harsh',
  m340: 'Modicon M340',
  m340_harsh: 'Modicon M340 harsh',
  x80: 'Modicon X80',
  x80_harsh: 'Modicon X80 harsh',
  x80_remote: 'Modicon X80 remote',
  x80_remote_harsh: 'Modicon X80 remote harsh',
  x80_safety: 'Modicon X80 safety',
  x80_remote_safety: 'Modicon X80 remote safety',
  x80_remote_safety_harsh: 'Modicon X80 remote safety harsh',
  m580_remote: 'Modicon M580 remote',
  m580_remote_harsh: 'Modicon M580 remote harsh',
  m580_hotstandby: 'Modicon M580 hotstandby',
  m580_hotstandby_harsh: 'Modicon M580 hotstandby harsh',
  m580_safety: 'Modicon M580 safety',
  m580_safety_harsh: 'Modicon M580 safety harsh',
  m580_hotstandby_safety: 'Modicon M580 hotstandby safety',
  m580_hotstandby_safety_harsh: 'Modicon M580 hotstandby safety harsh',
}


/**
 * This will be used to determine which bus expansion needs to be added for local racks.
 */
export const pac_harsh_ranges = [
  pac_ranges.m580_harsh,
  pac_ranges.m340_harsh,
  pac_ranges.m580_remote_harsh,
  pac_ranges.m580_hotstandby_harsh,
  pac_ranges.m580_safety_harsh,
  pac_ranges.m580_hotstandby_safety_harsh,
  pac_ranges.x80_remote_harsh
];

export const m580_distributed_ranges = [
  pac_ranges.m580_remote,
  pac_ranges.m580_remote_harsh,
  pac_ranges.m580_hotstandby,
  pac_ranges.m580_hotstandby_harsh,
  pac_ranges.m580_safety,
  pac_ranges.m580_safety_harsh,
  pac_ranges.m580_hotstandby_safety,
  pac_ranges.m580_hotstandby_safety_harsh,
  pac_ranges.x80_remote,
  pac_ranges.x80_remote_harsh,
  pac_ranges.x80_safety
];

export const m580_hotstandby_ranges = [
  pac_ranges.m580_hotstandby,
  pac_ranges.m580_hotstandby_harsh,
  pac_ranges.m580_hotstandby_safety,
  pac_ranges.m580_hotstandby_safety_harsh
];

export const mc80_range_id = '62396';

export const m172_battery_backup = 'Battery back-up';

export const pac_optical_fiber_converter = 'Optical fiber converter';

export const filter_types = {
  plc: 'PLC',
  io_island: 'IO_ISLAND'
}

export const available_ranges_for_time_cycle = [
  'Modicon TM5'
]

export const rangeIOModules = {
  tm3: 'TM3',
}

export const time_cycle = {
  sercos: [
    { maxModules: Infinity, maxBytes: 260, time_cycle: 1.0 },
    { maxModules: Infinity, maxBytes: 500, time_cycle: 2.0 },
    { maxModules: Infinity, maxBytes: 1400, time_cycle: 4.0 },
  ],
  eip: [
    { maxModules: 80, maxBytes: 300, time_cycle: 1.0 }
  ],
}

export const protocols = {
  eip: 'EtherNet/IP',
  modbusTCP: 'Modbus TCP',
  sercos: 'Sercos',
  canOpen: 'CANOpen',
  modbusSL: 'Modbus SL',
  xBus: 'Xbus'
}

export const AUTHENTIFICATION_IMPLEMENTATION = {
  CIAM: 'ciam',
  OKTA: 'okta'
}

export const seamlessEnvironments = {
  sandbox: {
    tokenValidationUrl: 'https://secureidentity-uat.schneider-electric.com/identity/services/apexrest/custom/userinfo',
  },
  prod: {
    tokenValidationUrl: 'https://secureidentity.schneider-electric.com/identity/services/apexrest/custom/userinfo',
  }
}

export const candidateAccessoryType = {
  recommanded: 'Recommanded',
  mandatory: 'Mandatory'
}

export const powerSupplyVoltageCompatibilityCriteria = 'Output voltage';

export const questionHintTypes = {
  'default': 0,
  'dropdown': 1
}

export const rule_categories = {
  consumption: 'consumption',
  range: 'range'
}

export const call_by_range_category_range_mapping = {
  lmc: ['PacDrive LMC Eco', 'PacDrive LMC Pro2', ],
  m262: ['Modicon M262', 'Modicon M262 light'],
  m251: ['Modicon M251', 'Modicon M251 2coms'],
  m241: ['Modicon M241'],
  m221: ['Modicon M221'],
  m171: ['Modicon M171 Optimized'],
  m172: ['Modicon M172 Optimized', 'Modicon M172 Performance'],
  m173: ['Modicon M173 Optimized'],
  zeliolog: ['Zelio Logic SR2', 'Zelio Logic SR3', 'Zelio Logic SR3 24Vdc'],
  m580: [pac_ranges.m580, pac_ranges.m580_harsh, pac_ranges.m580_remote, pac_ranges.m580_remote_harsh,
    pac_ranges.m580_hotstandby, pac_ranges.m580_hotstandby_harsh, pac_ranges.m580_safety, pac_ranges.m580_hotstandby_safety, pac_ranges.m580_safety_harsh, pac_ranges.m580_hotstandby_safety_harsh,
  ],
  m340: ['Modicon M340', 'Modicon M340 harsh'],
  mc80: ['Modicon MC80'],
  edge_bc: ['Modicon Edge IO NTS']
}

export const LICENSE_SELECTOR_SOFTWARES = {
  AUTOMATION_EXPERT: 'ecostruxure_automation_expert',
  CONTROL_EXPERT: 'ecostruxure_control_expert',
  PROCESS_EXPERT: 'ecostruxure_process_expert',
  CONTROL_ENGINEERING: 'ecostruxure_control_engineering'
};

export const call_by_range_category_id_mapping = {
  63072: ['lmc'],
  65771: ['m262'],
  62130: ['m251'],
  62129: ['m241'],
  62128: ['m221'],
  62420: ['m171', 'm172', 'm173'],
  531: ['zeliolog'],
  62098: ['m580'],
  1468: ['m340'],
  62396: ['mc80'],
  223435768: ['edge'],
  23643079: [LICENSE_SELECTOR_SOFTWARES.AUTOMATION_EXPERT],
  548: [LICENSE_SELECTOR_SOFTWARES.CONTROL_EXPERT],
  65406: [LICENSE_SELECTOR_SOFTWARES.PROCESS_EXPERT],
  39982702: [LICENSE_SELECTOR_SOFTWARES.CONTROL_ENGINEERING]
};

export const surveyTypes = {
  intermediate: 'plc_survey.json',
  generic: 'generic_survey.json'
}

export const surveyEventTypes = {
  generic_open: 'generic_open',
  intermediate_open: 'intermediate_open',
  generic_sent: 'generic_sent',
  intermediate_sent: 'intermediate_sent'
}

export const eventForceShowingSurvey = 'iac-force-showing-survey';

export const tm171amb = 'TM171AMB';

export const tm172sig = 'TM172SIG';

export const m171_need_amb = 'Modbus Gateway programmable controllers';

export const tm171_communication_module_type = 'Modbus communication module';

export const powerSupplyFieldBus = "Power supply Field and Bus";

export const edgeClusterHead = "Edge Cluster Head";

export const edgeClusterTermination = "Cluster Bus Termination";
export const DOCUMENT_TYPES = {
  PRODUCT_DATASHEET: "Product Data Sheet",
  CAD: "CAD",
  INSTRUCTION_SHEET: "Instruction sheet",
  USER_GUIDE: "User guide",
  CERTIFICATE: "Certificate",
  CATALOG: "Catalog"
}

export const documentationKeys = [
  DOCUMENT_TYPES.PRODUCT_DATASHEET,
  DOCUMENT_TYPES.CAD,
  DOCUMENT_TYPES.INSTRUCTION_SHEET,
  DOCUMENT_TYPES.USER_GUIDE,
  DOCUMENT_TYPES.CERTIFICATE,
  DOCUMENT_TYPES.CATALOG
];

export const licenseDocumentationKeys = [
  DOCUMENT_TYPES.PRODUCT_DATASHEET,
  DOCUMENT_TYPES.USER_GUIDE,
  DOCUMENT_TYPES.CATALOG
];

export const clusterTerminationData = {
  id: 'NTSXMP0000H',
  height: 100,
  width: 15
};

export const OPTION_CATEGORIES = {
  ACCESSORIES: 'accessories',
  AUXILIARIES: 'auxiliaries',
  SENSORS: 'sensors',
  SPARE_PARTS: 'spareParts',
  OPTIONS: 'options',
  WARRANTIES: 'warranties'
};

export const m580_complex_connection_colors = {
  classic: '#42B4E6',
  optical_fiber: '#F2C82B',
  xbus: 'black'
};

export const PAC_EXTENSION_MODULES = {
  BMXXBE1000: 'BMXXBE1000',
  BMXXBE1000H: 'BMXXBE1000H'
};

export const LICENSE_MODELS = {
  PERPETUAL: 'perpetual',
  SUBSCRIPTION: 'subscription'
};


export const PAC_RUGGEDIZATION = {
  HARSH: 'harsh',
  NON_HARSH: 'non harsh'
}

export const M580_SAFETY_COPROCESSOR = 'BMEP58CPROS3';

export const M580_SAFETY_COPROCESSOR_TYPE = 'Safety Coprocessor';

export const RENDER_M580_ARCHITECTURE_SCHEMA = false;

export const RACK_PAC_TYPES = {
  ETHERNET: 'Ethernet',
  XBUS: 'Xbus'

};

export const TOOL_MAIN_TECHNOLOGIES = {
  MODICON_CONTROLLERS: 'modicon_controllers',
  SOFTWARE_LICENCE_CONFIGURATOR: 'software_licence'
};

export const BUY_AUTOMATION_URLS = {
  sandbox: {
    APP_URL: 'https://staging.ba.schneider-electric.com/showroom/',
    ADD_TO_CART: 'https://staging.ba.schneider-electric.com/apiextcfg/LineItems',
    CART_LANDING_PAGE: 'https://staging.ba.schneider-electric.com/showroom/TeamBuy/BasketList.asp?mscssid=',
    CHECK_ACCOUNT: 'https://staging.ba.schneider-electric.com/apiextcfg/ShopperID',
  },

  prod: {
    APP_URL: 'https://buyautomation.se.com/showroom/',
    ADD_TO_CART: 'https://buyautomation.se.com/apiextcfg/LineItems',
    CART_LANDING_PAGE: 'https://buyautomation.se.com/showroom/TeamBuy/BasketList.asp?mscssid=',
    CHECK_ACCOUNT: 'https://buyautomation.se.com/apiextcfg/ShopperID'
  }
};

export const SUBSTITUTION_TYPE_REPLACE = "Replace";

export const SUBSTITUTION_TYPE_REMOVE = "Remove";

export const DATA_LAYER_EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  ADD_TO_CART: 'add_to_cart',
  FILE_DOWNLOAD: 'file_download',
  CTA_CLICK: 'cta_click'
};

export const IAC_ANALYTICS_EVENT = 'IAC-ANALYTICS-EVENT';
export const IAC_SEND_MAIL_EVENT_NAMES = {
  SEND_MAIL: 'SEND_MAIL',
  OPEN_MAIL: 'OPEN_MAIL'
};

export const PRECOMM_STATUS = '06';

export const EXTERNAL_SYSTEM_EVENT_NAMES = {
  PUBLIC_JOURNEY_ADD_TO_PROJECT : 'PJ_IAC_ADD_TO_MY_PROJECT',
  MYSCHNEIDER_ADD_TO_PROJECT: 'PLC_ADD_TO_MY_PROJECT',
  UNIFIED_CHECKOUT_ADD_TO_CART: 'ADD_TO_MY_CART',
  UNIFIED_CHECKOUT_ADD_TO_LIST: 'ADD_TO_MY_LIST'
};

export const WIDGET_WRAPPER_ADDTO = {
  CART: 'cart',
  LIST: 'list'
}

export const MY_SCHNEIDER_CONFIGURATORS_PAGE_SOURCE = 'MySchneider-configurators-page';
